import { Adresse } from "../../konfigurator_html/global/Adresse";
import { WarenkorbProduktionsarten } from "./warenkorbTypes";
export var Zahlarten;
(function (Zahlarten) {
    Zahlarten["PAYPAL"] = "PayPal";
    Zahlarten["PAYPALPLUS"] = "PayPalPlus";
    Zahlarten["UEBERWEISUNG"] = "\u00DCberweisung";
    Zahlarten["SCHECK"] = "Scheck";
    Zahlarten["KREDITKARTE"] = "Kreditkarte";
    Zahlarten["KLARNA_IDEAL"] = "Klarna \u00FCber iDeal";
    Zahlarten["KLARNA_SOFORT"] = "Klarna Sofort";
    Zahlarten["APPLEPAY"] = "ApplePay";
    Zahlarten["POSTFINANCE"] = "PostFinance";
    Zahlarten["IDEAL"] = "iDeal";
    Zahlarten["BANCONTACT"] = "Bancontact";
    Zahlarten["KLARNA_RECHNUNGSKAUF"] = "Klarna Rechnungskauf";
    Zahlarten["KREDITKARTE_BRAINTREE"] = "Kreditkarte \u00FCber Braintree";
    Zahlarten["KREDITKARTE_LYRA"] = "Kreditkarte \u00FCber Lyra";
    Zahlarten["PAYPAL_BRAINTREE"] = "PayPal \u00FCber Braintree";
    Zahlarten["NOPAYMENT"] = "nopayment";
    Zahlarten["TWINT"] = "Twint";
})(Zahlarten || (Zahlarten = {}));
export class WarenkorbZahlart {
}
export class WarenkorbZahlarten {
    constructor(zahlungsarten = [], ueberweisungsdaten = null, akzeptierteKreditkarten = []) {
        this.zahlungsarten = [];
        this.akzeptierteKreditkarten = [];
        this.getZahlart = (zahlart) => this.zahlungsarten.find(z => z.zahlart === zahlart) || null;
        this.zahlungsarten = zahlungsarten;
        this.ueberweisungsdaten = ueberweisungsdaten;
        this.akzeptierteKreditkarten = akzeptierteKreditkarten;
    }
    addZahlungsarten(zahlungsarten = []) {
        const $this = this;
        zahlungsarten.forEach(function (item) {
            $this.zahlungsarten.push(WarenkorbZahlarten.getWarenkorbZahlart(item));
        });
    }
    static getWarenkorbZahlart(item) {
        const zahlart = new WarenkorbZahlart();
        zahlart.zahlart = item.zahlart;
        zahlart.onlinePayment = item.onlinePayment;
        zahlart.onlineTemplate = item.onlineTemplate;
        zahlart.kuerzel = item.kuerzel;
        return zahlart;
    }
}
export class WarenkorbRabatt {
    constructor() {
        this.code = "";
        this.message = "";
        this.ende = null;
        this.absolutBetrag = 0;
        this.prozent = 0;
        this.valid = false;
        this.kundenKonfiRabatt = 0;
        this.maxAnzahlExemplare = -1;
        this.freeStandardShipping = false;
    }
}
export var DESIGNCHECKARTEN;
(function (DESIGNCHECKARTEN) {
    DESIGNCHECKARTEN["OWAYO"] = "owayo";
    DESIGNCHECKARTEN["SPEED"] = "speed";
    DESIGNCHECKARTEN["NONE"] = "kein";
})(DESIGNCHECKARTEN || (DESIGNCHECKARTEN = {}));
export class OwayoWarenkorb {
    constructor() {
        this.termine = null;
        this.liefertermin = null;
        this.gewaehlteProduktionsart = WarenkorbProduktionsarten.STANDARD;
        this.moeglicheZahlarten = null;
        this.waehrung = "";
        this.versandOption = null;
        this.spediteur = "";
        this.versandart = "";
        this.moeglicheVersandarten = null;
        this.gewaehlterDesigncheck = null;
        this.speedCheckAvailable = true;
        this.gesamtPreis = 0;
        this.userChosePaymentAfterApproval = false;
        this.wechselkurs = 1;
        this.designcheckPauschale = 0;
        this.datumBestellt = null;
        this.anzeigeNamenSpediteur = null;
        this.inklusiveMwSt = true;
        this.Shop = null;
        this.lieferAdresseIsTheSameAsRechnungsAdresse = () => { var _a, _b; return ((_a = this.lieferadresse) === null || _a === void 0 ? void 0 : _a.id) === ((_b = this.rechnungsadresse) === null || _b === void 0 ? void 0 : _b.id); };
        this.lieferadresse = OwayoWarenkorb.getNulledOutAdresse();
        this.rechnungsadresse = OwayoWarenkorb.getNulledOutAdresse();
        this.items = [];
        this.rabatt = new WarenkorbRabatt();
        this.zahlart = Zahlarten.KREDITKARTE;
    }
    static getNulledOutAdresse() {
        return new Adresse(null, null, null, null, null, null, null, null, null, null, null, "");
    }
    static lieferPositionIsArtikel(item) {
        return item.typ === "Artikel";
    }
    hasTshirt() {
        return this.items.some(i => i.ordertype === "Oberteil veredelt");
    }
    hasRechnungsadresse() {
        return this.rechnungsadresse !== null && this.rechnungsadresse.id !== null;
    }
}
//# sourceMappingURL=Warenkorb.js.map